import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { openSubscribeGate, useSubscription } from "../lib/subscription";

/**
 * StickyTryFreePill — appears after the user scrolls ~600px, sits above
 * the mobile safe area, and gives a persistent low-friction way to start
 * the 7-day free trial. Auto-hides once the user reaches the Pricing section
 * (so it doesn't compete with the primary pricing CTAs), and disappears
 * entirely once the visitor is already subscribed.
 */
export const StickyTryFreePill = () => {
  const [visible, setVisible] = useState(false);
  const { isSubscribed } = useSubscription();

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY > 600;
      const pricing = document.getElementById("pricing");
      const nearPricing =
        pricing &&
        pricing.getBoundingClientRect().top < window.innerHeight * 0.85;
      setVisible(scrolled && !nearPricing);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (isSubscribed) return null;

  return (
    <button
      type="button"
      onClick={() => openSubscribeGate("sticky-pill")}
      data-testid="sticky-try-free-pill"
      aria-label="Start free trial"
      className={`fixed z-40 left-1/2 -translate-x-1/2 bottom-4 md:bottom-6
        brand-gradient text-black font-semibold text-sm rounded-full
        px-4 py-2.5 md:px-5 md:py-3 shadow-[0_10px_40px_-8px_rgba(57,255,20,0.55)]
        inline-flex items-center gap-2 whitespace-nowrap
        transition-all duration-500 ease-out cursor-pointer
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"}`}
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full rounded-full bg-black/40 opacity-75 animate-ping" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-black" />
      </span>
      Start 7-day free trial
      <ArrowRight className="w-3.5 h-3.5" strokeWidth={2.5} />
    </button>
  );
};
